module.exports = __webpack_public_path__ + "media/images/triangle--down-d7a2b19f0661d2b189a3c134a1858dcc.png";